import { Component, Input, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import {
  CoreDataEntity,
  DataService,
  IPersistable,
  PersistenceService,
  PersistMode,
  QueryColumn,
} from '@barthauer/abc/core/data';
import { ResourceManager } from '@barthauer/abc/core/resources';
import {
  DialogResult,
  MessageBoxButtons,
  MessageBoxIcon,
  MessageBoxService,
  MessageMode,
  MessageSettings,
} from '@barthauer/abc/messages';
import { ExpressionsEditorComponent } from '@barthauer/abc/queries/opath/expressions-editor';
import {
  AbcButtonComponent,
  AbcContainerService,
  AbcGridComponent,
  AbcTextAreaComponent,
  AbcWindowComponent,
  ColumnHeader,
  DataType,
  GridStyle,
  IGrid,
  IWindow,
  WindowStyle,
} from '@barthauer/abc/ui-components';
import { Observable } from 'rxjs';
import { PropertiesEditorsService } from '../../services/properties-editors.service';

@Component({
  selector: 'test-app-properties-editor-details',
  templateUrl: './properties-editor-details.component.html',
  styleUrls: ['./properties-editor-details.component.scss'],
})
export class PropertiesEditorDetailsComponent implements OnInit {
  @ViewChild('abcWindowContainer', { read: ViewContainerRef }) abcWindow: ViewContainerRef;
  @ViewChild('addRowButton', { static: true }) addRowButton: AbcButtonComponent;
  @ViewChild('saveRowButton', { static: true }) saveRowButton: AbcButtonComponent;
  @ViewChild('exitButton', { static: true }) exitButton: AbcButtonComponent;
  @ViewChild('abcGridContainer', { static: true, read: ViewContainerRef }) abcGrid: AbcGridComponent;
  public pickList: any;
  public layOutGroup: any;
  private parentId: string;
  private _parentInfo: CoreDataEntity;
  private objectType: string;
  private windowInstance: AbcWindowComponent;
  private layoutViewModelData;
  private gridInstance;
  @Input()
  get parentInfo(): CoreDataEntity {
    return this._parentInfo;
  }
  set parentInfo(data) {
    this.parentId = data.id;
    this.prepareRequestProperty(data.id).subscribe((data) => {
      this.generateGrid(data);
    });
  }
  columnsHeader: ColumnHeader[];
  public res = ResourceManager.getResources('abc-properties');

  constructor(
    private abcContainer: AbcContainerService,
    private persistenceService: PersistenceService,
    private messageBoxService: MessageBoxService,
    private propertiesEditorsService: PropertiesEditorsService,
    private coreDataService: DataService,
    public iconRegistry: MatIconRegistry,
    public sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIcon(
      'expressioneditor',
      sanitizer.bypassSecurityTrustResourceUrl('assets/images/expressioneditor.svg')
    );
  }

  ngOnInit() {
    this.prepareRequestPickList().subscribe((data) => {
      this.pickList = data;
      this.columnsHeader[2].dropDownSource = this.pickList;
    });
    this.prepareRequestKonfigDocument().subscribe((data) => {
      this.layOutGroup = data;
      this.columnsHeader[4].dropDownSource = this.layOutGroup;
    });
    this.columnsHeader = [
      {
        name: 'Designation',
        dataField: 'Designation',
        type: DataType.String,
        editable: true,
      },
      {
        name: 'Type',
        dataField: 'typeColumn',
        type: DataType.DropDownList,
        editable: true,
        valueExpr: 'Type',
        displayExpr: 'Designation',
        cellEnabled: true,
        dropDownSource: [
          { Type: 0, Designation: 'Text' },
          { Type: 1, Designation: 'Numeric' },
          { Type: 2, Designation: 'Yes / no' },
          { Type: 3, Designation: 'Pick list' },
          { Type: 4, Designation: 'List of values' },
          { Type: 5, Designation: 'Confuguration document' },
        ],
      },
      {
        name: 'Pick list',
        dataField: 'Picklist',
        cellEnabled: false,
        type: DataType.DropDownList,
        editable: true,
        displayExpr: 'Designation',
        valueExpr: 'Name',
        dropDownSource: this.pickList,
      },
      {
        name: 'List of values',
        dataField: 'ListOfValues',
        type: DataType.String,
        editable: false,
        cellEnabled: false,
      },
      {
        name: 'Konfig.-Dokumenttyp',
        dataField: 'KonfigDokumenttyp',
        cellEnabled: false,
        type: DataType.DropDownList,
        displayExpr: 'Designation',
        valueExpr: 'Id',
        editable: true,
        dropDownSource: this.layOutGroup,
      },
      {
        name: 'Category',
        dataField: '',
        type: DataType.String,
        editable: true,
      },
      {
        name: 'Konfig.-Dok. XPath-Filter',
        dataField: 'KonfigDokXPathFilter',
        type: DataType.Button,
        cellEnabled: false,
        actionSvgIconName: 'assets/images/KAOS_Icon_Kommentare_wenig_Zeilen_128x128.png',
        actionMethod: () => this.openMultiLineEditor(),
      },
      {
        name: 'Visible',
        dataField: '',
        type: DataType.Button,
        editable: true,
        actionSvgIconName: 'assets/images/detailsWebArena_32x32.png',
        actionMethod: () => {
          this.createExpressionsOpath();
        },
        /* run opath expression */
      },
    ];
    this.addRowButton.addEventListener('click', () => {
      this.gridInstance.addEmptyRow('last');
    });
    this.saveRowButton.addEventListener('click', () => {
      const objectKey: IPersistable = {
        id: null,
        objectType: 'Property',
        persistenceCategory: null,
        changesPersisted: (persistMode) => (persistMode = PersistMode.Insert),
        revertChanges: () => {},
      };
      this.gridInstance.onRowInserted.subscribe(
        (event) => {
          let rowData = event.event.data;
          if (rowData) {
            this.persistenceService.addObjectForInsert(objectKey);
            this.addObjectValue(rowData, objectKey);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    });

    this.exitButton.addEventListener('click', () => {
      const settings = new MessageSettings();
      settings.mode = MessageMode.Question;
      settings.icon = MessageBoxIcon.Question;
      settings.button = MessageBoxButtons.YesNoCancel;
      settings.message = this.res('PropertiesEditorDetails-ConfirmExitMessage');
      this.messageBoxService.showMessageBox(settings).subscribe((result: DialogResult) => {
        if (DialogResult.No === result['result']) {
          this.propertiesEditorsService.callCloseDialogSubject();
        } else if (DialogResult.Yes === result['result']) {
          this.saveDataProperties();
          this.propertiesEditorsService.callCloseDialogSubject();
        }
      });
    });
  }

  private addObjectValue(rowData, objectKey: IPersistable) {
    for (const property in rowData) {
      this.persistenceService.addObjectValue(objectKey, property, rowData[property]);
    }
    this.persistenceService.addObjectValue(objectKey, 'ParentId', this.parentId);
    this.persistenceService.addObjectValue(objectKey, 'ParentObjectType', this.objectType);
    this.persistenceService.persistPendingChanges();
  }

  public openMultiLineEditor() {
    const style: WindowStyle = {
      width: '700px',
      height: '700px',
    };
    const WindowAttr: IWindow = {
      id: 'defineProperties',
      label: this.res('PropertiesEditor-DefineProperties'),
      minimizeButton: false,
      maximizeButton: false,
      component: AbcTextAreaComponent,
      setWindowStyle: (windowStyle: WindowStyle) => {
        windowStyle = style;
      },
    };
    const window = this.abcContainer.createComponent('', AbcWindowComponent, WindowAttr);
    this.windowInstance = <AbcWindowComponent>window.componentRef.instance;
    this.windowInstance.createComponentInstance().subscribe((activeComponent) => {
      activeComponent.openWindow();
      activeComponent.onAfterOpened.subscribe(() => {});
    });
  }

  private generateGrid(data) {
    const style: GridStyle = {
      width: '100%',
      height: 'calc(100% - 33px)',
      sortable: true,
      pageable: true,
      autorowheight: false,
      showemptyrow: false,
      editable: true,
    };
    const GridAttr: IGrid = {
      id: 'gridDefineProperties',
      columnsHeader: this.columnsHeader,
      gridData: data,
      setGridStyle: (GridStyle: GridStyle) => {
        GridStyle = style;
      },
    };
    const grid = this.abcContainer.createComponent(this.abcGrid, AbcGridComponent, GridAttr);
    this.gridInstance = <AbcGridComponent>grid.componentRef.instance;
    this.gridInstance.style = 4;

    this.gridInstance.onValueChanged.subscribe((event) => {
      if (event.value === 3) {
        this.columnsHeader[2].cellEnabled = true;
        this.columnsHeader[3].cellEnabled = false;
        this.columnsHeader[4].cellEnabled = false;
      } else if (event.value === 4) {
        this.columnsHeader[2].cellEnabled = false;
        this.columnsHeader[3].cellEnabled = true;
        this.columnsHeader[4].cellEnabled = false;
      } else if (event.value === 5) {
        this.columnsHeader[2].cellEnabled = false;
        this.columnsHeader[3].cellEnabled = false;
        this.columnsHeader[4].cellEnabled = true;
      }
      this.gridInstance.columnsHeader = this.columnsHeader;
    });
  }

  public save(): void {
    this.saveDataProperties();
  }

  public exit(): void {}

  private saveDataProperties(): void {}

  private prepareRequestPickList(): Observable<any> {
    const queryColumn = new Array<QueryColumn>();
    queryColumn.push(
      {
        OPath: 'Designation',
        Name: 'Designation',
      },
      {
        OPath: 'Name',
        Name: 'Name',
      },
      {
        OPath: 'Id',
        Name: 'Id',
      }
    );
    const observable = new Observable((observer) => {
      const query = this.coreDataService.createSimpleQuery('', 'Picklist', 'Language =1031', queryColumn);
      this.coreDataService.executeReadObjectsQuery(query).subscribe((data) => {
        this.pickList = data;
        observer.next(this.pickList);
      });
    });
    return observable;
  }

  private prepareRequestKonfigDocument(): Observable<any> {
    const queryColumn = new Array<QueryColumn>();
    queryColumn.push(
      {
        OPath: 'Designation',
        Name: 'Designation',
      },
      {
        OPath: 'Id',
        Name: 'Id',
      }
    );
    const observable = new Observable((observer) => {
      const query = this.coreDataService.createSimpleQuery('BaSYS.Master', 'MGroupItem', '', queryColumn);
      this.coreDataService.executeReadObjectsQuery(query).subscribe((data) => {
        observer.next(data);
      });
    });
    return observable;
  }

  private prepareRequestProperty(ParentId): Observable<any> {
    const queryColumn = new Array<QueryColumn>();
    queryColumn.push(
      {
        OPath: 'Designation',
        Name: 'Designation',
      },
      {
        OPath: 'Type',
        Name: 'Type',
      },
      {
        OPath: 'TextValue',
        Name: 'TextValue',
      }
    );
    const observable = new Observable((observer) => {
      const query = this.coreDataService.createSimpleQuery(
        '',
        'Property',
        "ParentId='${parentInfo.id}'" + "'" + ParentId + "'" + '',
        queryColumn
      );
      this.coreDataService.executeReadObjectsQuery(query).subscribe((data) => {
        observer.next(data);
      });
    });
    return observable;
  }

  openDetailsWindow() {
    const style: WindowStyle = {
      width: '40%',
      height: '605px',
      minWidth: '450px',
    };
    const WindowAttr: IWindow = {
      id: 'multiline-text-editor',
      label: 'multiline text editor',
      minimizeButton: false,
      maximizeButton: false,
      component: '',
      setWindowStyle: (windowStyle: WindowStyle) => {
        windowStyle = style;
      },
    };
    const window = this.abcContainer.createComponent(this.abcWindow, AbcWindowComponent, WindowAttr);
    this.windowInstance = <AbcWindowComponent>window.componentRef.instance;
    this.windowInstance.createComponentInstance().subscribe((activeComponent) => {
      activeComponent.openWindow();
    });
  }

  createExpressionsOpath() {
    const style: WindowStyle = {
      width: '810px',
      height: '600px',
      // toolBarColor: '#443161',
      // titleColor: 'white',
    };
    const WindowAttr: IWindow = {
      id: 'window-expressioneditor',
      label: 'WebArena Ausdruckseditor',
      logo: 'expressioneditor',
      maximizeButton: true,
      minimizeButton: true,
      component: ExpressionsEditorComponent,
      setWindowStyle: (windowStyle: WindowStyle) => (windowStyle = style),
    };
    let window = this.abcContainer.createComponent(this.abcWindow, AbcWindowComponent, WindowAttr);
    let windowInstance = <AbcWindowComponent>window.componentRef.instance;
    windowInstance.createComponentInstance().subscribe((activeComponent) => {
      activeComponent.openWindow();
      activeComponent.onAfterOpened.subscribe(() => {});
    });
  }
}
